import React from 'react'
import { InferGetServerSidePropsType } from 'next'
import { BuilderComponent } from '@builder.io/react'

import Footer from 'client/components/Footer'

import { getServerSideProps } from 'src/pages/builder/server'
import { registerBuilderComponents } from 'src/pages/builder/builderUtils'

registerBuilderComponents()

const pagePathView = '/the-brand/[path]'
const pageId = 'corporate'

type Props = InferGetServerSidePropsType<typeof getServerSideProps>

export default (props: Props) => {
  const { builderContent, config } = props

  return (
    <>
      <BuilderComponent locale={config.locale} model="page" content={builderContent} />
      <Footer />
    </>
  )
}

export { pageId, pagePathView }

export { getServerSideProps }
